/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/**
 * Header cart: keep the subtotal and the empty state in sync.
 *
 * theme.js re-renders the mini-cart after every AJAX cart change but only ever
 * rewrites `.header__cart-count` — so a subtotal rendered by Liquid at page
 * load goes stale the moment something is added. It signals the re-render with
 * a `cart:rerendered` CustomEvent dispatched on the header section element.
 *
 * That event is dispatched WITHOUT `bubbles` in the mini-cart path, so a
 * listener on document only sees it during the capture phase — `bubbles: false`
 * suppresses the bubble phase, not the capture phase. Hence the `true` below.
 */
(function () {
  var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';

  // Mirrors Shopify's money_format placeholders. theme.js has an equivalent
  // Currency.formatMoney, but it is closed over inside the bundle's IIFE and
  // is not reachable from here.
  function formatMoney(cents, format) {
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;

      if (isNaN(number) || number === null) {
        return '0';
      }

      var fixed = (number / 100.0).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';

      return dollars + centsPart;
    }

    switch ((format.match(placeholder) || [])[1]) {
      case 'amount':
        value = withDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'");
        break;
      default:
        value = withDelimiters(cents, 2);
    }

    return format.replace(placeholder, value);
  }

  function syncHeaderCart() {
    var item = document.querySelector('.header__action-item--cart');

    if (!item) {
      return;
    }

    fetch(window.routes && window.routes.cartUrl ? window.routes.cartUrl + '.js' : '/cart.js', {
      credentials: 'same-origin',
      headers: { 'Cache-Control': 'no-cache' }
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart) {
          return;
        }

        var total = item.querySelector('[data-cart-total]');

        if (total) {
          total.textContent = formatMoney(cart.total_price, moneyFormat);
        }

        // Leave the count itself to theme.js — it is already authoritative.
        if (cart.item_count === 0) {
          item.setAttribute('data-cart-empty', '');
        } else {
          item.removeAttribute('data-cart-empty');
        }
      })
      .catch(function () {
        /* A failed refresh leaves the last known figure, which beats clearing it. */
      });
  }

  document.addEventListener('cart:rerendered', syncHeaderCart, true);
})();


/**
 * Collapsible copy with a "Read more" toggle.
 *
 * Used by the offer cards (where four blocks of wildly different length left the
 * shortest card two thirds empty) and by the image-with-text bands on mobile,
 * where the SEO copy is a wall of text once the two columns stack.
 *
 * The copy is clamped in CSS, never removed from the DOM, so crawlers and
 * screen readers still get the whole thing — the toggle only changes what is
 * painted.
 *
 * Markup contract:
 *   [data-expandable]                  the element that carries the state classes
 *   [data-expandable-class]            class prefix, e.g. "offer-item" gives
 *                                      offer-item--collapsed / --expanded
 *   [data-expandable-content]          the block that gets clamped
 *   [data-expandable-toggle]           the button; starts hidden and is revealed
 *                                      only if the content actually overflows
 *   [data-expandable-max-width]        optional; only collapse at or below this
 *                                      viewport width
 */
(function () {
  function prefix(root) {
    return root.getAttribute('data-expandable-class') || 'is';
  }

  function applies(root) {
    var max = root.getAttribute('data-expandable-max-width');
    return !max || window.matchMedia('(max-width: ' + max + 'px)').matches;
  }

  function measure(root) {
    var content = root.querySelector('[data-expandable-content]');
    var toggle = root.querySelector('[data-expandable-toggle]');

    if (!content || !toggle) {
      return;
    }

    var p = prefix(root);

    // Above the breakpoint there is nothing to collapse: drop the state and the
    // control entirely rather than leaving a dead button in the layout.
    if (!applies(root)) {
      root.classList.remove(p + '--collapsed', p + '--expanded');
      toggle.hidden = true;
      return;
    }

    // Never re-measure mid-expansion — the answer would always be "fits".
    if (root.classList.contains(p + '--expanded')) {
      return;
    }

    root.classList.add(p + '--collapsed');

    var overflows = content.scrollHeight > content.clientHeight + 1;

    toggle.hidden = !overflows;

    if (!overflows) {
      root.classList.remove(p + '--collapsed');
    }
  }

  function measureAll() {
    document.querySelectorAll('[data-expandable]').forEach(measure);
  }

  function toggleRoot(toggle) {
    var root = toggle.closest('[data-expandable]');
    var label = toggle.querySelector('[data-expandable-label]');
    var p = prefix(root);
    var expanded = root.classList.toggle(p + '--expanded');

    root.classList.toggle(p + '--collapsed', !expanded);
    toggle.setAttribute('aria-expanded', String(expanded));

    if (label) {
      label.textContent = expanded
        ? toggle.getAttribute('data-label-less')
        : toggle.getAttribute('data-label-more');
    }
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('[data-expandable-toggle]');

    if (toggle) {
      event.preventDefault();
      toggleRoot(toggle);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', measureAll);
  } else {
    measureAll();
  }

  // A clamp measured against the fallback face can be a line out once the
  // webfont swaps in.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(measureAll);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(measureAll, 150);
  });

  // Theme editor re-renders blocks on edit.
  document.addEventListener('shopify:section:load', measureAll);
  document.addEventListener('shopify:block:select', measureAll);
})();


/**
 * Hero height: publish the header's real height as a CSS variable.
 *
 * The hero is sized so a fixed slice of the section below it stays above the
 * fold. That subtraction needs the header's height, and a `vh` unit cannot see
 * it — `55vh` is 55% of the whole viewport, header included, so the hero grew
 * or shrank independently of what was actually pushing it down the page.
 *
 * The header is also not one height: it restacks at the tablet and phone
 * breakpoints and the announcement bar can be dismissed, so this is measured
 * rather than hardcoded, and re-measured on resize and when the bar closes.
 *
 * custom.css §30 reads `--hs-header-h` and falls back to 150px if this never
 * runs, which keeps the hero sane with JS disabled.
 */
(function () {
  var header = document.querySelector('#shopify-section-header') ||
               document.querySelector('.header');
  if (!header) return;

  var announcement = document.querySelector('#shopify-section-announcement-bar');

  function publish() {
    var h = header.getBoundingClientRect().height +
            (announcement ? announcement.getBoundingClientRect().height : 0);
    document.documentElement.style.setProperty('--hs-header-h', Math.round(h) + 'px');
  }

  publish();
  window.addEventListener('resize', publish);
  window.addEventListener('load', publish);

  /* The bar is removed from the flow, not hidden, so observe the wrapper. */
  if (announcement && window.ResizeObserver) {
    new ResizeObserver(publish).observe(announcement);
  }
})();
